import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Register.css';

export default function Register() {
  const navigate = useNavigate();

  // Backend URL from config.js
  const [backendUrl, setBackendUrl] = useState('');

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    phone: "",
    designation:"",
    location: "",
    department: "",
  });

  const [status, setStatus] = useState('');
  const [verificationMessage, setVerificationMessage] = useState('');

  // Load backend URL from public/config.js
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '/config.js';
    script.onload = () => {
      if (window.env?.BACKEND_URL) {
        console.log('BACKEND_URL loaded:', window.env.BACKEND_URL);
        setBackendUrl(window.env.BACKEND_URL);
      } else {
        console.error('BACKEND_URL not found in config.js');
      }
    };
    script.onerror = () => console.error('Failed to load config.js');
    document.body.appendChild(script);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!backendUrl) {
      setStatus('Configuration not loaded yet. Try again.');
      return;
    }

    const { username, email, password } = formData;
    if (!username || !email || !password) {
      setStatus('Please fill in all required fields.');
      return;
    }

    try {
      await axios.post(`${backendUrl}/register`, formData);

      //  Show email verification message instead of auto-login
      setVerificationMessage(
        '✔ Registration successful! Please check your email to verify your account before logging in.'
      );

      // Clear form
      setFormData({
        username: "",
        email: "",
        password: "",
        phone: "",
        designation: "",
        location: "",
        department: "",
      });

      setStatus(''); // clear generic status if any
    } catch (err) {
      console.error('Registration error:', err);
      setStatus(err.response?.data?.message || 'Registration failed. Please try again.');
      setVerificationMessage('');
    }
  };

  return (
    <div className="register-container">
      <h2 className="register-title">Create an Account</h2>

      <form className="register-form" onSubmit={handleRegister}>
        <label>Username:</label>
        <input
          type="text"
          name="username"
          placeholder="Enter username"
          value={formData.username}
          onChange={handleChange}
          className="input-field"
          required
        />

        <label>Email:</label>
        <input
          type="email"
          name="email"
          placeholder="Enter email"
          value={formData.email}
          onChange={handleChange}
          className="input-field"
          required
        />

        <label>Password:</label>
        <input
          type="password"
          name="password"
          placeholder="Enter password"
          value={formData.password}
          onChange={handleChange}
          className="input-field"
          required
        />

        <label>Phone Number:</label>
        <input
          type="text"
          name="phone"
          placeholder="Enter phone number"
          value={formData.phone}
          onChange={handleChange}
          className="input-field"
        />

        <label>Designation:</label>
        <input
          type="text"
          name="designation"
          placeholder="Enter designation"
          value={formData.designation}
          onChange={handleChange}
          className="input-field"
        />

        <label>Current Location:</label>
        <input
          type="text"
          name="location"
          placeholder="Enter current location"
          value={formData.location}
          onChange={handleChange}
          className="input-field"
        />

        <label>Department:</label>
        <input
          type="text"
          name="department"
          placeholder="Enter department"
          value={formData.department}
          onChange={handleChange}
          className="input-field"
        />

        <button
          type="submit"
          className="btn submit-btn"
          disabled={!!verificationMessage} // prevent multiple clicks after registration
        >
          Register
        </button>
      </form>

      {/* Display status or verification message */}
      {status && <p className="status-message" style={{ color: 'red' }}>{status}</p>}
      {verificationMessage && (
        <p className="status-message" style={{ color: 'green', marginTop: '10px' }}>
          {verificationMessage}
        </p>
      )}

      <button className="btn back-btn" onClick={() => navigate('/')}>
        Back to Home
      </button>
    </div>
  );
}
